import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { Tenant } from '@/types/auth'

export function useTenants() {
  return useQuery({
    queryKey: ['tenants'],
    queryFn: async (): Promise<Tenant[]> => {
      const { data, error } = await supabase
        .from('tenants')
        .select('*')
        .order('created_at', { ascending: false })

      if (error) {
        throw error
      }

      return data as Tenant[]
    },
  })
}
